var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.45 13.77H7.18l-.83-7.99H20.9l-1.45 7.99zM9.58 18.8c.57 0 1.04.49 1.04 1.1 0 .61-.47 1.1-1.04 1.1-.57 0-1.03-.49-1.03-1.1 0-.61.46-1.1 1.03-1.1zm8.21 2.2c-.57 0-1.03-.49-1.03-1.1 0-.61.46-1.1 1.03-1.1.57 0 1.04.49 1.04 1.1 0 .61-.47 1.1-1.04 1.1zm4.09-16.04c-.09-.11-.23-.18-.38-.18H6.25l-.24-2.33c-.03-.26-.24-.45-.5-.45H2.5c-.28 0-.5.22-.5.5s.22.5.5.5h2.56l.24 2.28v.06l.93 8.99.39 3.78c.03.26.24.45.5.45h.9c-.29.36-.47.83-.47 1.34 0 1.16.91 2.1 2.03 2.1 1.12 0 2.04-.94 2.04-2.1 0-.52-.19-1-.5-1.36l5.15-.02c-.32.37-.51.85-.51 1.38 0 1.16.91 2.1 2.03 2.1 1.12 0 2.04-.94 2.04-2.1 0-.54-.2-1.03-.53-1.4h.05c.27 0 .5-.23.49-.5 0-.28-.22-.5-.5-.5l-11.77.06-.29-2.79h12.59c.25 0 .45-.17.49-.41l1.63-8.99c.03-.14-.01-.29-.11-.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.317 11.78c-.25 0-.468-.19-.496-.445l-.462-4.24c-.03-.274.168-.52.442-.55.264-.03.52.166.55.44l.466 4.24c.03.275-.168.522-.442.552-.02.002-.037.003-.056.003"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.05b58d585f385abf40ce5e86331830fd.svg";
export { ForwardRef as ReactComponent };